import { useEffect, useState } from 'react'
import { Callout, FormScroll, FormSection, toastError } from 'admination-react'
import { anleitungPdf } from '@/core/data/anleitung'
import { PdfRegion, ZOOMED_OUT_PDF_SCALE } from '@/core/components/modal/PdfRegion'

const FAILED = 'Die Anleitung konnte nicht geladen werden.'

export function AnleitungSection({ url }: { url: string }) {
  const [blob, setBlob] = useState<Blob | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancelled = false
    setBlob(null)
    setFailed(false)
    anleitungPdf(url).then(
      (pdf) => {
        if (!cancelled) setBlob(pdf)
      },
      (e: unknown) => {
        if (cancelled) return
        console.error('Anleitung laden fehlgeschlagen:', e)
        setFailed(true)
        toastError(FAILED)
      },
    )
    return () => {
      cancelled = true
    }
  }, [url])

  if (failed) {
    return (
      <FormScroll>
        <FormSection>
          <Callout tone="error" role="alert">
            {FAILED}
          </Callout>
        </FormSection>
      </FormScroll>
    )
  }
  return (
    <PdfRegion

      path={null}
      localBlob={blob}
      waiting={!blob}
      loadingLabel="Anleitung wird geladen …"
      placeholder={FAILED}
      scaleFactor={ZOOMED_OUT_PDF_SCALE}
      reading
      testId="anleitung"
    />
  )
}
